

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	function getSlidesPerGroup(slidesSizesGrid, visibleSlidesIndexes) {
		const totalSlide = slidesSizesGrid.length;
		const visibleSlide = visibleSlidesIndexes?.length ?? 1;

		let slidesPerGroup = visibleSlide;

		if (totalSlide <= visibleSlide) {
			slidesPerGroup = null;
		}
		return slidesPerGroup;
	}
	function triggerLozadNextSlideImage(swiper) {
		const nextSlide = swiper.slides[swiper.activeIndex + 1];
		if (nextSlide) {
			const nextImage = nextSlide.querySelectorAll("img");
			if (nextImage && typeof lazyLoader.triggerLoad === "function") {
				nextImage.forEach((img) => {
					lazyLoader.triggerLoad(img);
				});
			} else {
				throw new Error("Lozad is not defined");
			}
		}
	}
	function autoSetSlidesPerGroup(swiper) {
		if (!swiper.pagination.el) return;
		const { visibleSlidesIndexes, slidesSizesGrid } = swiper;
		const slidesPerGroup = getSlidesPerGroup(
			slidesSizesGrid,
			visibleSlidesIndexes
		);
		if (
			slidesPerGroup != null &&
			slidesPerGroup > 0 &&
			slidesPerGroup !== swiper.params.slidesPerGroup
		) {
			swiper.params.slidesPerGroup = slidesPerGroup;
			swiper.update();
		}
	}


	window.initSwiper = [];
	$(".init-swiper .swiper").each(function (index) {
		const $this = $(this);
		let isLoop = false;
		let time = $(this).attr("data-time") || 5000;
		let isTriggerLoadedNext = false;

		// --- NEW CODE START ---
		// Check if the specific class exists to determine pagination type
		let paginationType = "bullets";
		if ($this.hasClass("progress-pagination")) {
			paginationType = "progressbar";
		}
		// --- NEW CODE END ---

		if ($this.hasClass("trigger-loaded-next")) {
			isTriggerLoadedNext = true;
		}

		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		const options = {
			observer: true,
			observeParents: true,
			rewind: true,
			speed: 1205,
			watchSlidesProgress: true,
			lazy: {
				loadPrevNext: true,
			},
			loop: isLoop,
			autoplay: {
				delay: time,
				pauseOnMouseEnter: true,
			},
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: paginationType, // <--- Updated here to use the variable
				clickable: true,
				dynamicMainBullets: 1,
			},
			on: {
				beforeInit: function () {
					window.initSwiper.push(this);
				},
				init: function (swiper) {
					if (isLoop) {
						lozadInit();
						$(this.el)
							.find(".swiper-slide-duplicate a[data-fancybox]")
							.each(function () {
								$(this).removeAttr("data-fancybox");
							});
					}
					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},
				afterInit: function () {
					//
				},
				slideChange: function () {
					if ($this.hasClass("slide-has-video")) {
						$this.find("video")[0].pause();
						$this.find(".swiper-slide").removeClass("play-video");
						$this.find(".play-btn").removeClass("active");
					}

					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},

				resize: function (swiper) {
					// console.log("resize ");
					const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
						(acc, curr) => acc + curr,
						0
					);
					swiper.el.classList.toggle(
						"center-slide-active",
						totalSlidesWidth < swiper.size
					);
					autoSetSlidesPerGroup(this);
				},
			},
		};
		if (time == 0) {
			options.autoplay = {
				delay: 0,
				disableOnInteraction: true,
				pauseOnMouseEnter: false,
			};
			options.loop = true;
			options.speed = 1800;
			delete options.navigation;
		}
		var swiper_slide_auto = new Swiper(".swiper-init-" + index, {
			...options,
		});
	});

	var primaryBanner = new Swiper(".primary-banner .swiper", {
		observer: true,
		spaceBetween: 10,
		observeParents: true,
		breakpoints: {
			200: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
			1280: {
				slidesPerView: 1,
				spaceBetween: 100,

			},
		},

		speed: 1205,
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".primary-banner  .next",
			prevEl: ".primary-banner  .prev ",
		},

	});
	var gridSwiper = new Swiper(".grid-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 20,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 10,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 10,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			768: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				spaceBetween: 20,
				slidesPerView: 3,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			1201: {
				spaceBetween: 20,
				slidesPerView: 4,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

		},
		navigation: {
			nextEl: ".grid-swiper .next",
			prevEl: ".grid-swiper .prev",
		},
	});




}